/**
 * `canary local list` — List all local environments for the current user.
 *
 * @module
 */

import { resolveConfig } from '../auth.js';
import { fetchProperties, fetchList } from '../cli-helpers.js';

interface LocalEnvironment {
  id: string;
  name: string;
  url: string;
  propertyId: string;
}

export async function runLocalList(argv: string[]) {
  const config = await resolveConfig(argv);

  const properties = await fetchProperties(config.apiUrl, config.token);

  if (properties.length === 0) {
    console.log('No properties found.');
    return;
  }

  const rows: Array<{ envId: string; property: string; name: string; url: string }> = [];

  for (const property of properties) {
    const envs = await fetchList<LocalEnvironment>(
      config.apiUrl,
      config.token,
      `/org/properties/${property.id}/environments/local`,
      'items'
    );

    for (const env of envs) {
      rows.push({
        envId: env.id,
        property: property.name,
        name: env.name,
        url: env.url,
      });
    }
  }

  if (rows.length === 0) {
    console.log('No local environments found. Run `canary local init` to create one.');
    return;
  }

  // Print table
  const headers = ['ENV ID', 'PROPERTY', 'NAME', 'URL'];
  const widths = headers.map((h, i) => {
    const col = [h, ...rows.map((r) => Object.values(r)[i])];
    return Math.max(...col.map((v) => v.length));
  });

  const sep = widths.map((w) => '-'.repeat(w)).join('  ');
  const formatRow = (vals: string[]) => vals.map((v, i) => v.padEnd(widths[i])).join('  ');

  console.log(formatRow(headers));
  console.log(sep);
  for (const row of rows) {
    console.log(formatRow([row.envId, row.property, row.name, row.url]));
  }
}
